import { IconType } from 'react-icons';
import { FaBolt, FaCouch, FaCrown, FaRandom } from 'react-icons/fa';
import { BadgeTone } from './Badge';

export interface ChipMeta {
  label: string;
  Icon: IconType;
  tone: BadgeTone;
  /** For rendering the icon on its own, outside a Badge. Both themes verified at >= 3:1. */
  iconClass: string;
}

const CHIP_META: Record<string, ChipMeta> = {
  wildcard: { label: 'Wildcard', Icon: FaRandom, tone: 'purple', iconClass: 'text-purple-800 dark:text-purple-300' },
  freehit: { label: 'Free Hit', Icon: FaBolt, tone: 'amber', iconClass: 'text-amber-800 dark:text-amber-300' },
  bboost: { label: 'Bench Boost', Icon: FaCouch, tone: 'emerald', iconClass: 'text-emerald-800 dark:text-emerald-300' },
  '3xc': { label: 'Triple Captain', Icon: FaCrown, tone: 'pink', iconClass: 'text-pink-800 dark:text-pink-300' },
};

export const getChipMeta = (name: string): ChipMeta =>
  CHIP_META[name?.toLowerCase()] ?? {
    label: name,
    Icon: FaRandom,
    tone: 'neutral',
    iconClass: 'text-content-muted',
  };
